import axios from 'axios';

// Creăm o instanță "personalizată" de axios
const apiClient = axios.create({
  // Setăm URL-ul de bază al backend-ului nostru
  baseURL: 'https://api.osace.ro/api', 
});

// Folosim un "interceptor" pentru a modifica fiecare cerere ÎNAINTE să plece
apiClient.interceptors.request.use(
  (config) => {
    // Preluăm token-ul din localStorage
    const token = localStorage.getItem('userToken');
    
    // Dacă token-ul există, îl adăugăm la headerele cererii
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config; // Trimitem cererea modificată mai departe
  },
  (error) => {
    // Tratăm erorile de configurare a cererii
    return Promise.reject(error);
  }
);

// Exportăm instanța configurată pentru a o folosi în componente
export default apiClient;